package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PaletteW500Rounded: ImageVector
    get() {
        if (_paletteW500Rounded != null) {
            return _paletteW500Rounded!!
        }
        _paletteW500Rounded = Builder(name = "PaletteW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 888.13f)
                quadToRelative(-83.63f, 0.0f, -158.09f, -32.22f)
                quadToRelative(-74.45f, -32.21f, -130.03f, -87.79f)
                quadToRelative(-55.58f, -55.58f, -87.79f, -130.04f)
                quadToRelative(-32.22f, -74.46f, -32.22f, -158.09f)
                quadToRelative(0.0f, -84.66f, 32.98f, -159.1f)
                quadToRelative(32.98f, -74.43f, 89.55f, -129.63f)
                quadToRelative(56.58f, -55.19f, 132.0f, -87.29f)
                quadToRelative(75.41f, -32.1f, 161.02f, -32.1f)
                quadToRelative(81.54f, 0.0f, 154.09f, 28.1f)
                quadToRelative(72.56f, 28.1f, 127.37f, 77.67f)
                quadToRelative(54.82f, 49.58f, 87.03f, 117.44f)
                quadToRelative(32.22f, 67.86f, 32.22f, 146.44f)
                quadToRelative(0.0f, 116.44f, -70.36f, 181.52f)
                quadToRelative(-70.36f, 65.09f, -173.47f, 65.09f)
                horizontalLineToRelative(-68.5f)
                quadToRelative(-8.04f, 0.0f, -11.42f, 4.52f)
                quadToRelative(-3.38f, 4.52f, -3.38f, 10.28f)
                quadToRelative(0.0f, 11.53f, 13.57f, 31.16f)
                quadToRelative(13.56f, 19.63f, 13.56f, 47.43f)
                quadToRelative(0.0f, 51.91f, -30.13f, 79.26f)
                quadToRelative(-30.13f, 27.35f, -78.0f, 27.35f)
                close()
                moveTo(480.0f, 480.0f)
                close()
                moveTo(305.87f, 503.0f)
                quadToRelative(17.0f, -17.0f, 17.0f, -43.0f)
                reflectiveQuadToRelative(-17.0f, -43.0f)
                quadToRelative(-17.0f, -17.0f, -43.0f, -17.0f)
                reflectiveQuadToRelative(-43.0f, 17.0f)
                quadToRelative(-17.0f, 17.0f, -17.0f, 43.0f)
                reflectiveQuadToRelative(17.0f, 43.0f)
                quadToRelative(17.0f, 17.0f, 43.0f, 17.0f)
                reflectiveQuadToRelative(43.0f, -17.0f)
                close()
                moveTo(424.43f, 345.15f)
                quadToRelative(17.0f, -17.0f, 17.0f, -43.0f)
                reflectiveQuadToRelative(-17.0f, -43.0f)
                quadToRelative(-17.0f, -17.0f, -43.0f, -17.0f)
                reflectiveQuadToRelative(-43.0f, 17.0f)
                quadToRelative(-17.0f, 17.0f, -17.0f, 43.0f)
                reflectiveQuadToRelative(17.0f, 43.0f)
                quadToRelative(17.0f, 17.0f, 43.0f, 17.0f)
                reflectiveQuadToRelative(43.0f, -17.0f)
                close()
                moveTo(621.57f, 345.15f)
                quadToRelative(17.0f, -17.0f, 17.0f, -43.0f)
                reflectiveQuadToRelative(-17.0f, -43.0f)
                quadToRelative(-17.0f, -17.0f, -43.0f, -17.0f)
                reflectiveQuadToRelative(-43.0f, 17.0f)
                quadToRelative(-17.0f, 17.0f, -17.0f, 43.0f)
                reflectiveQuadToRelative(17.0f, 43.0f)
                quadToRelative(17.0f, 17.0f, 43.0f, 17.0f)
                reflectiveQuadToRelative(43.0f, -17.0f)
                close()
                moveTo(739.41f, 503.0f)
                quadToRelative(17.0f, -17.0f, 17.0f, -43.0f)
                reflectiveQuadToRelative(-17.0f, -43.0f)
                quadToRelative(-17.0f, -17.0f, -43.0f, -17.0f)
                reflectiveQuadToRelative(-43.0f, 17.0f)
                quadToRelative(-17.0f, 17.0f, -17.0f, 43.0f)
                reflectiveQuadToRelative(17.0f, 43.0f)
                quadToRelative(17.0f, 17.0f, 43.0f, 17.0f)
                reflectiveQuadToRelative(43.0f, -17.0f)
                close()
                moveTo(478.57f, 797.13f)
                quadToRelative(8.46f, 0.0f, 13.63f, -4.73f)
                quadToRelative(5.17f, -4.74f, 5.17f, -12.31f)
                quadToRelative(0.0f, -14.0f, -15.12f, -32.17f)
                quadToRelative(-15.12f, -18.16f, -15.12f, -55.2f)
                quadToRelative(0.0f, -43.2f, 29.83f, -69.39f)
                quadToRelative(29.83f, -26.2f, 73.04f, -26.2f)
                horizontalLineToRelative(74.3f)
                quadToRelative(65.53f, 0.0f, 109.18f, -38.26f)
                quadToRelative(43.65f, -38.26f, 43.65f, -115.67f)
                quadToRelative(0.0f, -121.0f, -92.02f, -200.67f)
                quadToRelative(-92.02f, -79.66f, -217.69f, -79.66f)
                quadToRelative(-134.57f, 0.0f, -229.56f, 92.28f)
                quadToRelative(-94.99f, 92.28f, -94.99f, 224.96f)
                quadToRelative(0.0f, 131.69f, 92.3f, 224.36f)
                quadToRelative(92.31f, 92.66f, 223.4f, 92.66f)
                close()
            }
        }
        .build()
        return _paletteW500Rounded!!
    }

private var _paletteW500Rounded: ImageVector? = null
